import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

@Injectable()
export class InformacionService {

  info:any= {};
  cargada:boolean = false;

  cargada_sobre_nostoros:boolean = false;
  equipo:any= [];

  constructor( public http:Http ) {
    this.carga_info();
    this.carga_sobre_nosotros();
   }

   public carga_info() {
     this.http.get("assets/data/info.pagina.json")
     .subscribe( data=> {
       this.cargada = true;
       this.info = data.json();
     })
   }



   public carga_sobre_nosotros() {
     this.http.get("https://paginaweb-41864.firebaseio.com/equipo.json")
     .subscribe( data=> {
       this.cargada_sobre_nostoros = true;
       this.equipo = data.json();
       console.log(this.equipo);
     })
   }

}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/services/informacion.service.ts